<template>
  <div v-if="ready" class="nav-container notAuthNav" :class="getNavClasses">
    <div class="navbar" :class="navBackgroundLight ? 'navbar-light' : ''">
      <a href="/" class="logo">
        <div class="logoIcon">
          <IconBase icon-name="logo-icon" iconColor="#444" viewBox="83.799 83.799 821.229 821.229" width="100%" height="100%" strokeWidth="0px"
            ><LogoIconBlack
          /></IconBase>
        </div>
        <div class="logoText">
          <IconBase icon-name="logo-text" iconColor="#444" viewBox="1072.626 310.056 2011.173 376.864" width="100%" height="100%" strokeWidth="0px"
            ><LogoTextBlack
          /></IconBase>
        </div>
        <!-- <div class="beta" v-show="$windowWidth > 520">Beta</div> -->
      </a>
      <div :class="$windowWidth <= 520 ? 'mobile-nav' : ''">
        <CrazyTownMaster v-show="$windowWidth > 350" icon="🦄" iconType="unicorn" />
        <!-- <CrazyTownMaster icon="🚀" iconType="rocket" /> -->
        <a
          v-if="!$route.meta.isLogin"
          href="/account/login"
          class="nav-button"
          :style="$windowWidth > 520 ? 'margin-right: 12px;' : 'margin-right: 6px;'"
          >Login</a
        >
        <span v-if="!$route.meta.isRegister" @click="registerFromNav" class="nav-button join-now" style="border: 2px solid; border-radius: 360px"
          >Join now</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import IconBase from "../../components/IconBase";
// import IconLogo from "../../../components/SVG/IconLogo";
import LogoIconBlack from "../../components/SVG/LogoIconBlack";
import LogoTextBlack from "../../components/SVG/LogoTextBlack";
import CrazyTownMaster from "./Sections/CrazyTownMaster";

export default {
  name: "LandingNav",
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      ready: (state) => state.auth.ready,
    }),
    profileLink: function () {
      let handle = this.user.username ? this.user.username : this.user.displayName;
      return `/profile/${handle}`;
    },
    getNavClasses() {
      let classes = "";
      if (this.navBackgroundLight) {
        classes = classes + " " + "nav-light";
      }
      if (this.$route.meta.newLandingPage) {
        classes = classes + " " + "new-landing-nav-container";
      }
      return classes;
    },
  },
  props: {
    navBackgroundLight: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    IconBase,
    // IconLogo,
    LogoIconBlack,
    LogoTextBlack,
    CrazyTownMaster,
  },
  data() {
    return {
      buttonText: "Resend email",
      emailSentCounter: 0,
      // loading: true,
    };
  },
  created() {
    window.addEventListener("beforeunload", this.cleanBeforeLeave);
  },
  methods: {
    async cleanBeforeLeave(fromBeforeLeave = false, next = null) {
      window.removeEventListener("beforeunload", this.cleanBeforeLeave);
      if (fromBeforeLeave && next !== null) {
        next();
      }
    },
    registerFromNav() {
      window.mixpanel.track("Sign Up via Nav Bar");
      window.location = "/account/register";
    },
  },
};
</script>

<style scoped>
.beta {
  border-radius: 360px;
  border: 1px solid;
  padding: 2px 5px;
  font-size: 9px;
  font-weight: 700;
  margin-bottom: 9px;
  font-family: "F37 Ginger Regular", sans-serif;
  margin-left: -2px;
  background-color: #111;
  color: white;
}
.unverified {
  font-size: 21px;
  text-align: center;
  background-color: #bf0000;
  color: white;
  padding: 5px;
}
.nav-container {
  z-index: 980;
  padding: 10px 5px;
  /* position: absolute;
  width: 100%;
  top: 0;  */
}
.navbar {
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
  /* font-family: "Trebuchet MS", sans-serif; */
  font-family: "Nunito", sans-serif;
  /* font-weight: 700; */
  align-items: center;

  padding: 8px 36px;
  transform: scale(1.03);
}
.nav-button {
  padding: 7px 14px;
  border-radius: 3px;
  cursor: pointer;
  color: #abadb9;
  color: #111;
  font-weight: 600;
  font-size: 18px;
  font-family: "F37 Ginger Regular";
}
.nav-logo {
  padding: 8px 14px;
  cursor: pointer;
  font-weight: 600;
  color: #abadb9;
}
.nav-logo:hover {
  color: #3e3a54;
}
.nav-button:hover {
  /* background-color: #f7f7fb; */
  color: #3e3a54;
}

.username {
  padding: 11px 11px;
  border-radius: 6px;
  /* background-color: #f3f4f7eb; */
  border: 1px solid transparent;
  cursor: pointer;
  position: relative;
  padding-right: 34px;
}

.username:hover {
  /* background-color: #f2f3f5eb; */
  /* background-color: #f3f4f7eb; */
  background-color: #f3f4f7eb;
  /* border: 1px solid #eee; */
}

.dropdown-active {
  background-color: #f3f4f7eb;
  /* border: 1px solid #eee; */
  color: #3e3a54;
}

.dropdown-icon {
  position: absolute;
  height: 17px;
  width: 19px;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 11px;
  border: none !important;
  background-color: unset !important;
}

.nav-container .logo {
  /* height: 30px; */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 4px;
  transform: scale(1.1);

  margin-left: 18px;
  transform: scale(1.2);
}

.nav-container .logoIcon {
  width: 25px;
  height: 25px;
}

.nav-container .logoText {
  height: 13px;
  width: 84px;
}

.nav-container {
  padding-top: 5px;
}

.join-now:hover {
  background-color: black;
  color: white;
  border-color: black !important;
}

.mobile-nav {
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-light {
  background-color: #fbfbfb !important;
}
.navbar-light {
  background-color: #fbfbfb !important;
}

.new-landing-nav-container {
  height: 60px;
}

@media screen and (max-width: 520px) {
  .nav-container {
    padding: 10px 5px;
    padding-top: 7px;
    box-sizing: border-box;
  }
  .navbar {
    transform: scale(1);
    box-sizing: border-box;
    padding: 8px 10px;
  }
  .nav-button {
    padding: 8px 12px;
    font-size: 17px;
  }
  .nav-container .logo {
    margin-left: 7px;
  }
}

@media screen and (max-width: 410px) {
  .nav-button {
    padding: 8px 12px;
    font-size: 17px;
  }
}

@media screen and (max-width: 350px) {
  .nav-button {
    padding: 8px 10px;
  }
}
</style>
